module.exports = __webpack_public_path__ + "img/index-img-05.96a60792.png";